<ft-modal-overlay [open]="!!config()">
  @if (config(); as config) {
    <ft-modal-chrome-ng
      [headerText]="config.title || ''"
      [headerDescription]="config.description || ''"
      [size]="config.size || 'sm'"
      [doneText]="config.doneText || 'Save'"
      [doneVisible]="true"
      [doneDisabled]="doneDisabled(config)"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onDone()"
      (cancel)="onCancel()"
    >
      @switch (config.type) {
        @case ('bool') {
          <ft-bool-field-ng
            [datasource]="resolveDatasource(config)"
            [fields]="config.fields"
           />
        }
        @case ('text') {
          <ft-text-field-ng
            [datasource]="resolveDatasource(config)"
            [fields]="config.fields"
            [fieldsOptions]="config.fieldsOptions"
           />
        }
        @case ('number') {
          <ft-number-field-ng
            [datasource]="resolveDatasource(config)"
            [fields]="config.fields"
            [fieldsOptions]="config.fieldsOptions"
           />
        }
        @case ('textarea') {
          <ft-textarea-field-ng
            [datasource]="resolveDatasource(config)"
            [fields]="config.fields"
            [fieldsOptions]="config.fieldsOptions"
           />
        }
        @case ('html') {
          <ft-html-field-ng
            [datasource]="resolveDatasource(config)"
            [fields]="config.fields"
            [fieldsOptions]="config.fieldsOptions"
           />
        }
        @case ('css') {
          <ft-code-field-ng
            [datasource]="resolveDatasource(config)"
            [fields]="config.fields"
            syntax="css"
           />
        }
        @case ('js') {
          <ft-code-field-ng
            [datasource]="resolveDatasource(config)"
            [fields]="config.fields"
            syntax="javascript"
           />
        }
      }
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>
